'use strict';

/**
 * Component for the object status
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../templates/components/field-status.hbs');

var StatusComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    attributes: {
        'data-selection': 'in-collection',
    },

    ui: {
        'statusSelect': 'input[name="status"]',
        'relationInput': 'input[name="relation"]',
    },

    events: {
        'change @ui.statusSelect': 'onChangeStatusSelect',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },

        relationField: function() {
            return this.relationField;
        },
    },

    initialize: function() {
        var field = this.getOption('field');
        var sourceFields = field.sourceFields;
        var catalog = this.model.collection.catalog;

        this.relationField = catalog.getFieldDefinition(sourceFields.relation);
    },

    onRender: function() {
        this.onChangeStatusSelect();
    },

    /**
     * Is triggered, when status selection has changed
     */
    onChangeStatusSelect: function() {
        var value = this.ui.statusSelect.filter(':checked').val();
        this.$el.attr('data-selection', value); //for css
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        data[field.name] = this.$('[name="status"]:checked').val()
        data[this.relationField.name] = this.$('[name="relation"]').val().trim();

        return data;
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
    },
});

module.exports = StatusComponent;